import {
  jobNurseSenkaUrl,
  njbUrl,
  recruitNurseSenkaUrl,
} from '../../../features/url/baseUrl';
import { ButtonMenu } from '../../Button/ButtonMenu';
import { FiExternalLinkIcon } from '../../Icon';

import styles from './MenuModal.module.scss';

import type { FC } from 'react';

import { AppEnv } from '@/packages/nurse-senka-frontend-sdk';

type Props = {
  appEnv: AppEnv;
};

export const SisterSiteBlock: FC<Props> = ({ appEnv }) => (
  <>
    <span className={styles['menu-title']}>姉妹サイト</span>
    <div className={styles.block}>
      <ButtonMenu
        icon={FiExternalLinkIcon}
        link={recruitNurseSenkaUrl(appEnv)}
        targetBlank={true}
      >
        ナース専科 就職
      </ButtonMenu>
      <ButtonMenu
        icon={FiExternalLinkIcon}
        link={jobNurseSenkaUrl(appEnv)}
        targetBlank={true}
      >
        ナース専科求人ナビ
      </ButtonMenu>
      <ButtonMenu
        icon={FiExternalLinkIcon}
        link={njbUrl(appEnv)}
        targetBlank={true}
      >
        ナース専科 転職
      </ButtonMenu>
    </div>
  </>
);
